export default __webpack_public_path__ + "static/media/rooms_light.ce3063ea.svg";